import { Injectable } from '@angular/core';

@Injectable()
export class paymentInfo {
  referenceId: string;
  urlContent: string;
  orderCode: string;
  errorCode: string;
  errorMessage: string;
}
